@if (!loaded) {
  <se-fe-spinner
    [seFeDataSize]="900"
    [seFeDataCenter]="true">
  </se-fe-spinner>
}
@if (loaded) {
  <se-fe-list>
    @for (listItem of listItems; track listItem) {
      <se-fe-list-item>
        <se-fe-header [seFeDataSize]="600">
          <se-fe-avatar seFeHeaderVisual seFeDataType="org"
            [seFeDataIdentity]="listItem.title"
            [seFeDataAriaLabel]="listItem.title"
            [seFeDataImgUrl]="listItem.image"
            seFeDataSize="200"
            style="margin-top: 4px;">
          </se-fe-avatar>
          <div seFeHeaderTitle class="organization-list-title">
            <a seFeLink="low" target="_blank" [href]="listItem.url">
              {{ listItem.title }}
              <se-fe-icon seFeDataName="launch" seFeDataSize="500" seFeDataColor="primary"></se-fe-icon>
            </a>
          </div>
          @if (listItem.menuOptions) {
            <div seFeHeaderActions>
              <se-fe-icon-button
                [seFeMenuTrigger]="listItemMenu"
                seFeDataEmphasis="low">
                <se-fe-icon seFeDataName="more" seFeDataSize="700"></se-fe-icon>
              </se-fe-icon-button>
              <se-fe-menu #listItemMenu [seFeDataOptions]="listItem.menuOptions"></se-fe-menu>
            </div>
          }
        </se-fe-header>
      </se-fe-list-item>
    }
  </se-fe-list>
}
@if (loaded && !listItems.length) {
  <se-fe-empty-state seFeDataTitle="No Organizations Found">
    <se-fe-icon seFeEmptyStateIcon seFeDataName="spot_whistle" seFeDataSize="950"></se-fe-icon>
  </se-fe-empty-state>
}
